if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const actionButton = evt.submitter || this.submitButton;
        const buyNow = actionButton.matches('[data-koko-buy-now]');
        if (this.submitting || actionButton.getAttribute('aria-disabled') === 'true' || actionButton.disabled) return;
        this.submitting = true;
        this.error = false;
        this.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[data-cart-add-status]');
        if (status) status.textContent = '';
        actionButton.querySelector('[data-cart-add-loading]')?.removeAttribute('hidden');

        this.handleErrorMessage();

        actionButton.setAttribute('aria-disabled', true);
        actionButton.classList.add('loading');
        actionButton.querySelector('.loading__spinner')?.classList.remove('hidden');

        const variantId = this.variantIdInput.value;
        this.dispatchKokoSizeDrawerResult('koko:product-form-start', variantId, '', actionButton);
        let cart;
        let requestStarted = false;

        Promise.resolve()
          .then(() => {
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            formData.set('id', variantId);
            // The drawer element can exist before its deferred script has upgraded it.
            if (
              this.cart &&
              ['getSectionsToRender', 'setActiveElement', 'renderContents'].every(
                (method) => typeof this.cart[method] === 'function'
              )
            ) {
              cart = this.cart;
            }
            if (cart && !buyNow) {
              formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
              const panel = this.closest('[data-koko-card-size-panel]');
              const trigger = panel?.id
                ? document.querySelector(`[data-koko-card-size-open][aria-controls="${CSS.escape(panel.id)}"]`)
                : null;
              cart.setActiveElement(trigger || document.activeElement);
            }
            config.body = formData;
            requestStarted = true;
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchKokoSizeDrawerResult('koko:product-form-error', variantId, response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (buyNow) {
              this.removeAttribute('aria-busy');
              if (await window.Koko15?.beforeCheckout() === false) return;
              window.location.assign(actionButton.dataset.checkoutUrl || '/checkout');
              return;
            } else if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (status) status.textContent = status.dataset.addedLabel;
            this.dispatchKokoSizeDrawerResult('koko:product-form-success', variantId);
            const renderCart = async () => {
              await cart.renderContents(response);
              Promise.resolve().then(() => publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
                renderedCart: cart,
              })).catch(console.error);
            };
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              await new Promise((resolve, reject) => {
                document.body.addEventListener(
                  'modalClosed',
                  () => renderCart().then(resolve, reject),
                  { once: true }
                );
                quickAddModal.hide(true);
              });
            } else {
              await renderCart();
            }
          })
          .catch((e) => {
            console.error(e);
            const message = (requestStarted && status?.dataset.unknownLabel) || window.cartStrings?.error || e.message;
            this.handleErrorMessage(message);
            this.dispatchKokoSizeDrawerResult(
              'koko:product-form-error',
              variantId,
              message
            );
          })
          .finally(() => {
            this.submitting = false;
            this.removeAttribute('aria-busy');
            actionButton.querySelector('[data-cart-add-loading]')?.setAttribute('hidden', '');
            actionButton.classList.remove('loading');
            if (!this.error) actionButton.removeAttribute('aria-disabled');
            actionButton.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      dispatchKokoSizeDrawerResult(eventName, variantId, message = '', submitter = null) {
        if (!this.closest('[data-koko-card-size-panel]')) return;
        this.dispatchEvent(
          new CustomEvent(eventName, {
            bubbles: true,
            detail: { variantId: String(variantId || ''), message, submitter },
          })
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
